module.exports = __webpack_public_path__ + "img/i-gaming.f0508a85.png";